import manasaImg from '../assets/manasa-f.jpg';
import ritvikImg from '../assets/Ritvik Reddy Gangula.jpg';

export const FLIP_CARDS = [
  {
    img: manasaImg,
    name: 'Manasa V',
    grade: 'Grade 12th',
    uni: 'UC, Los Angeles',
    quote: 'Manasa got admitted into UCLA for doing a Medical degree. In her own words, "The training I received at EduTechEx for SAT General and assistance for University placements are excellent which helped me to get into UCLA. Thank you EduTechEx.',
  },
  {
    img: ritvikImg,
    name: 'Ritvik Reddy',
    grade: 'Grade 12th',
    uni: 'Arizona State University, Tempe',
    quote: 'Computer Science has always been my passion. Initially my plan was to study in India, later through EDUTECHEX Ivy league program I came to know about the excellent opportunities for doing bachelors in the US. Thanks, EDUTECHEX for helping me through the entire application process.',
  },
];